export interface Show {
  id: number;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  episodeCount: number;
  currentEpisode: string;
  status: string;
  description: string;
  longDescription: string;
  coverImage: string;
  bannerImage: string;
  cast: string[];
  director: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateTime: string;
}

export const categories: { name: string; slug: string; icon: string }[] = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { name: '国产剧', slug: 'chinese', icon: 'ri-china-railway-line' },
  { name: '韩剧', slug: 'korean', icon: 'ri-global-line' },
  { name: '美剧', slug: 'american', icon: 'ri-flag-line' },
  { name: '日剧', slug: 'japanese', icon: 'ri-sun-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-tv-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
];

export const shows: Show[] = [
  {
    id: 1,
    title: '长安十二时辰',
    englishTitle: 'The Longest Day in Chang\'an',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2019,
    rating: 9.2,
    episodeCount: 48,
    currentEpisode: '全48集',
    status: '已完结',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。',
    longDescription: '天宝三年，上元节，长安城内张灯结彩，一片祥和。然而，一场惊天阴谋正在这座繁华都城中酝酿。突厥狼卫潜入长安，意图在灯会之时制造混乱。死囚张小敬被靖安司司丞李必从死牢中带出，必须在十二时辰内查出真相，否则整个长安将陷入万劫不复。本剧改编自马伯庸同名小说，以精良的制作、宏大的场景、紧凑的节奏赢得了观众的一致好评。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%2C%20Tang%20dynasty%20warrior%20in%20armor%20standing%20in%20ancient%20Changan%20city%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20photography&width=400&height=560&seq=show-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20Changan%20cityscape%20at%20night%20with%20lanterns%2C%20epic%20cinematic%20wide%20shot%2C%20mysterious%20atmosphere%2C%20dark%20and%20golden%20tones%2C%20movie%20banner%20style%2C%20dramatic%20mood%2C%20high%20production%20value&width=1600&height=700&seq=show-banner-01&orientation=landscape',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    director: '曹盾',
    tags: ['古装', '悬疑', '历史', '动作'],
    isHot: true,
    isNew: false,
    updateTime: '2019-08-12',
  },
  {
    id: 2,
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 9.5,
    episodeCount: 39,
    currentEpisode: '全39集',
    status: '已完结',
    description: '京海市一线刑警安欣与黑恶势力展开长达二十年的生死较量，一步步揭开黑恶势力背后的保护伞。',
    longDescription: '2000年，京海市的一起命案将刑警安欣与鱼贩高启强联系在了一起。此后二十年，安欣始终没有放弃对高启强及其背后黑恶势力的追查。从意气风发的青年刑警到满头白发的中年人，他用自己的青春和热血，捍卫了法律的尊严。本剧以真实案件为原型，展现了扫黑除恶的艰辛历程，引发全民追剧热潮。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20two%20men%20facing%20each%20other%20in%20dark%20urban%20alley%2C%20rain%2C%20neon%20lights%20reflection%2C%20tense%20atmosphere%2C%20cinematic%20noir%20style%2C%20movie%20poster%20design&width=400&height=560&seq=show-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20urban%20Chinese%20cityscape%20at%20night%20with%20neon%2C%20rainy%20streets%2C%20noir%20cinematic%20atmosphere%2C%20dramatic%20moody%20lighting%2C%20crime%20drama%20banner&width=1600&height=700&seq=show-banner-02&orientation=landscape',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    tags: ['刑侦', '犯罪', '现实主义', '剧情'],
    isHot: true,
    isNew: false,
    updateTime: '2023-01-14',
  },
  {
    id: 3,
    title: '黑暗荣耀',
    englishTitle: 'The Glory',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2023,
    rating: 9.3,
    episodeCount: 16,
    currentEpisode: '全16集',
    status: '已完结',
    description: '年少时遭受校园暴力的文东恩，精心策划了一场复仇计划，向施暴者和旁观者展开冷酷复仇。',
    longDescription: '文东恩在高中时期遭受了残酷的校园暴力，被迫退学。多年后，她成为了施暴者女儿的班主任，一场精心策划的复仇大戏就此拉开帷幕。宋慧乔颠覆形象的演技、金恩淑编剧的精彩剧本，让这部复仇爽剧成为2023年最受瞩目的韩剧之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%2C%20elegant%20woman%20in%20black%20standing%20in%20front%20of%20a%20luxurious%20mansion%2C%20cold%20expression%2C%20dark%20aesthetic%2C%20revenge%20theme%2C%20cinematic%20poster%20style&width=400&height=560&seq=show-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Elegant%20dark%20Korean%20aesthetic%2C%20luxury%20mansion%20interior%20with%20dramatic%20shadows%2C%20mysterious%20woman%20silhouette%2C%20revenge%20drama%20mood%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=show-banner-03&orientation=landscape',
    cast: ['宋慧乔', '李到晛', '林智妍', '朴成焄'],
    director: '安吉镐',
    tags: ['复仇', '校园暴力', '剧情', '悬疑'],
    isHot: true,
    isNew: false,
    updateTime: '2023-03-10',
  },
  {
    id: 4,
    title: '三体',
    englishTitle: 'Three-Body',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 8.8,
    episodeCount: 30,
    currentEpisode: '全30集',
    status: '已完结',
    description: '纳米科学家汪淼被卷入一场关于外星文明的谜团中，揭开了地球文明与三体文明之间生死搏杀的序幕。',
    longDescription: '2007年，地球基础科学出现了异常扰动，纳米科学家汪淼与刑警史强联手调查，发现了一个名为"科学边界"的神秘组织。随着调查的深入，一个来自三体文明的惊天秘密逐渐浮出水面。改编自刘慈欣同名科幻巨著，以宏大的宇宙观和深刻的哲学思考震撼观众。',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20Chinese%20drama%20poster%2C%20three%20suns%20in%20alien%20sky%2C%20astronomical%20phenomenon%2C%20cosmic%20scale%2C%20mysterious%20atmosphere%2C%20cinematic%20poster%20design%2C%20dark%20space%20theme&width=400&height=560&seq=show-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Deep%20space%20cosmic%20panorama%20with%20three%20stars%2C%20alien%20civilization%2C%20vast%20universe%2C%20sci-fi%20cinematic%20atmosphere%2C%20dark%20and%20mysterious%20colors%2C%20epic%20scale&width=1600&height=700&seq=show-banner-04&orientation=landscape',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    tags: ['科幻', '悬疑', '宇宙', '哲学'],
    isHot: true,
    isNew: false,
    updateTime: '2023-01-15',
  },
  {
    id: 5,
    title: '请回答1988',
    englishTitle: 'Reply 1988',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2015,
    rating: 9.7,
    episodeCount: 20,
    currentEpisode: '全20集',
    status: '已完结',
    description: '1988年，首尔双门洞五家人的温馨故事，关于亲情、友情和爱情的最美青春回忆。',
    longDescription: '1988年的首尔道峰区双门洞，五个家庭、五个从小一起长大的孩子，在平凡的日常中书写着最动人的故事。没有惊天动地的情节，只有邻里间的温情、家人之间的牵绊、青春期的悸动。这部剧被誉为"人生韩剧"，每一集都能让人笑中带泪，回味无穷。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20retro%20drama%20poster%2C%20five%20teenagers%20sitting%20together%20in%201980s%20Korean%20neighborhood%2C%20warm%20nostalgic%20colors%2C%20vintage%20aesthetic%2C%20friendship%20theme%2C%20heartwarming%20poster%20style&width=400&height=560&seq=show-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1980s%20Korean%20neighborhood%20alley%20in%20Seoul%2C%20warm%20sunset%20light%2C%20nostalgic%20retro%20atmosphere%2C%20small%20houses%20close%20together%2C%20clothesline%2C%20heartwarming%20cinematic%20wide%20shot&width=1600&height=700&seq=show-banner-05&orientation=landscape',
    cast: ['李惠利', '朴宝剑', '柳俊烈', '高庚杓'],
    director: '申源浩',
    tags: ['青春', '家庭', '温情', '怀旧'],
    isHot: false,
    isNew: false,
    updateTime: '2016-01-16',
  },
  {
    id: 6,
    title: '庆余年',
    englishTitle: 'Joy of Life',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2019,
    rating: 9.0,
    episodeCount: 46,
    currentEpisode: '全46集',
    status: '已完结',
    description: '身世神秘的少年范闲，从海边小城来到京都，历经家族纷争、江湖险恶、庙堂权谋，书写了一段传奇人生。',
    longDescription: '范闲带着现代记忆穿越到架空古代世界，从小在澹州长大，后因身世之谜被卷入京都的权力旋涡。在庆国的舞台上，他凭借智慧和勇气，一步步揭开自己的身世秘密，同时也在权谋斗争中书写了自己的传奇。改编自猫腻同名小说，剧情跌宕起伏，笑点与泪点并存。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20drama%20poster%2C%20young%20man%20in%20elegant%20traditional%20robe%20holding%20sword%2C%20ancient%20Chinese%20palace%20background%2C%20epic%20fantasy%20style%2C%20cinematic%20composition&width=400&height=560&seq=show-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20panorama%2C%20grand%20architecture%2C%20golden%20rooftops%2C%20dramatic%20clouds%2C%20epic%20fantasy%20cinematic%20atmosphere%2C%20warm%20imperial%20colors&width=1600&height=700&seq=show-banner-06&orientation=landscape',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    tags: ['古装', '权谋', '武侠', '喜剧'],
    isHot: false,
    isNew: false,
    updateTime: '2019-12-20',
  },
  {
    id: 7,
    title: '鱿鱼游戏',
    englishTitle: 'Squid Game',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2021,
    rating: 8.9,
    episodeCount: 9,
    currentEpisode: '全9集',
    status: '已完结',
    description: '456名走投无路的人被邀请参加一场神秘游戏，胜者将获得456亿韩元奖金，败者将付出生命的代价。',
    longDescription: '成奇勋是一个生活困顿的离异父亲，背负巨额债务。某天，他在地铁站遇到一个神秘男子，邀请他参加一场游戏。当他和其他455名参赛者醒来时，发现自己身处一个神秘的封闭空间，穿着统一的绿色运动服。游戏规则很简单：赢得六场童年游戏即可获得456亿韩元。但他们很快发现，输掉游戏的代价是死亡。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%2C%20people%20in%20green%20tracksuits%20with%20numbered%20masks%2C%20dark%20surreal%20playground%2C%20geometric%20patterns%2C%20tense%20mood%2C%20minimalist%20poster%20design&width=400&height=560&seq=show-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Surreal%20Korean%20playground%20with%20giant%20doll%20and%20colorful%20stairs%2C%20eerie%20atmosphere%2C%20pastel%20colors%20contrasting%20dark%20theme%2C%20cinematic%20wide%20shot%2C%20mysterious&width=1600&height=700&seq=show-banner-07&orientation=landscape',
    cast: ['李政宰', '朴海秀', '魏嘏隽', '郑好娟'],
    director: '黄东赫',
    tags: ['惊悚', '生存', '社会', '剧情'],
    isHot: false,
    isNew: false,
    updateTime: '2021-09-17',
  },
  {
    id: 8,
    title: '琅琊榜',
    englishTitle: 'Nirvana in Fire',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2015,
    rating: 9.4,
    episodeCount: 54,
    currentEpisode: '全54集',
    status: '已完结',
    description: '十二年前被陷害全军覆没的赤焰军少帅林殊，化名梅长苏重返金陵，扶持明君、洗雪冤屈，谱写一曲荡气回肠的权谋史诗。',
    longDescription: '十二年前，七万赤焰军被奸佞陷害含冤埋骨梅岭，少帅林殊侥幸存活。十二年后，林殊化名"麒麟才子"梅长苏重返帝都金陵，拖着病弱之躯，以无双智谋，在波诡云谲的朝堂中运筹帷幄，扶持明君靖王登基，最终为七万赤焰忠魂洗雪了冤屈。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20scholar%20in%20white%20robe%20with%20fan%2C%20ancient%20Chinese%20study%20room%2C%20elegant%20and%20refined%2C%20classical%20aesthetic%2C%20cinematic%20poster%20design&width=400&height=560&seq=show-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20traditional%20architecture%20in%20distance%2C%20ink%20wash%20painting%20style%2C%20elegant%20classical%20Chinese%20aesthetic%2C%20ethereal%20atmosphere&width=1600&height=700&seq=show-banner-08&orientation=landscape',
    cast: ['胡歌', '刘涛', '王凯', '陈龙'],
    director: '孔笙',
    tags: ['古装', '权谋', '复仇', '经典'],
    isHot: false,
    isNew: false,
    updateTime: '2015-10-15',
  },
  {
    id: 9,
    title: '鬼怪',
    englishTitle: 'Guardian: The Lonely and Great God',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2016,
    rating: 9.1,
    episodeCount: 16,
    currentEpisode: '全16集',
    status: '已完结',
    description: '不死之身的鬼怪金侁，为了结束永恒的生命，需要找到一位人类新娘。当他遇到自称"鬼怪新娘"的少女池恩倬后，展开了一段浪漫又悲伤的故事。',
    longDescription: '高丽时期的大将军金侁因为受到王的猜忌而遇害，死后获得了诅咒般的"永生"能力，成为了拥有不死之身的鬼怪。为了结束永恒的生命，他必须找到一位能看到他身上的剑并拔出的人类新娘。900多年后，他遇到了自称"鬼怪新娘"的高中生池恩倬，一段关于爱情、生命与命运的故事就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20drama%20poster%2C%20man%20and%20woman%20in%20autumn%20maple%20scene%2C%20red%20scarf%2C%20romantic%20atmosphere%2C%20warm%20golden%20light%2C%20cinematic%20poster%20style&width=400&height=560&seq=show-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Autumn%20maple%20tree%20lined%20road%20in%20Korea%2C%20golden%20hour%20sunlight%2C%20romantic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20colors%2C%20dreamy%20aesthetic&width=1600&height=700&seq=show-banner-09&orientation=landscape',
    cast: ['孔刘', '金高银', '李栋旭', '刘寅娜'],
    director: '李应福',
    tags: ['奇幻', '爱情', '浪漫', '经典'],
    isHot: false,
    isNew: false,
    updateTime: '2017-01-21',
  },
  {
    id: 10,
    title: '鬼吹灯之精绝古城',
    englishTitle: 'Candle in the Tomb',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2016,
    rating: 8.7,
    episodeCount: 21,
    currentEpisode: '全21集',
    status: '已完结',
    description: '胡八一、王胖子和Shirley杨组成摸金校尉三人组，深入塔克拉玛干沙漠，探寻精绝古城的千年秘密。',
    longDescription: '退伍军人胡八一凭借祖传的《十六字阴阳风水秘术》，与好友王胖子一起开始了摸金校尉的生涯。在美国华人Shirley杨的资助下，三人深入塔克拉玛干大沙漠，寻找传说中的精绝古城。一路上，他们遭遇了沙漠行军蚁、火瓢虫、霸王蝾螈等各种诡异生物，最终揭开了精绝女王的神秘面纱。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20adventure%20drama%20poster%2C%20explorers%20in%20desert%20with%20ancient%20ruins%2C%20mysterious%20atmosphere%2C%20tomb%20raiding%20theme%2C%20cinematic%20adventure%20style%2C%20warm%20desert%20tones&width=400&height=560&seq=show-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20desert%20ruins%20at%20sunset%2C%20lost%20city%20in%20sand%2C%20mysterious%20atmosphere%2C%20adventure%20cinematic%20wide%20shot%2C%20warm%20golden%20desert%20colors&width=1600&height=700&seq=show-banner-10&orientation=landscape',
    cast: ['靳东', '陈乔恩', '赵达', '岳旸'],
    director: '孔笙',
    tags: ['冒险', '悬疑', '盗墓', '奇幻'],
    isHot: false,
    isNew: true,
    updateTime: '2026-08-01',
  },
  {
    id: 11,
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 9.3,
    episodeCount: 30,
    currentEpisode: '全30集',
    status: '已完结',
    description: '九十年代的上海，人人争上游。阿宝在改革开放的大潮中，从默默无闻到成为黄河路上叱咤风云的宝总，演绎了一段沪上传奇。',
    longDescription: '九十年代的上海，春风乍起，处处是机遇。阿宝凭借敏锐的商业嗅觉和人情练达，在黄河路上闯出了一片天。从南京路的时装店到外滩的股票交易所，从弄堂里的本帮菜馆到黄河路的大饭店，他经历了商海的浮沉、人情的冷暖。王家卫导演的电视剧处女作，以独特的影像美学和深情叙事，讲述了一个时代的上海故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%2C%20man%20in%20vintage%20suit%20on%20neon-lit%20street%2C%20retro%20Chinese%20aesthetic%2C%20nostalgic%20glamour%2C%20cinematic%20poster%20design%2C%20warm%20golden%20neon&width=400&height=560&seq=show-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20skyline%20at%20night%2C%20the%20Bund%2C%20neon%20signs%2C%20vintage%20Chinese%20city%2C%20nostalgic%20cinematic%20wide%20shot%2C%20warm%20retro%20aesthetic&width=1600&height=700&seq=show-banner-11&orientation=landscape',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    tags: ['年代', '商战', '上海', '剧情'],
    isHot: true,
    isNew: true,
    updateTime: '2024-01-09',
  },
  {
    id: 12,
    title: '寄生兽：灰色部队',
    englishTitle: 'Parasyte: The Grey',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 8.6,
    episodeCount: 6,
    currentEpisode: '全6集',
    status: '已完结',
    description: '神秘孢子降临地球，寄生生物侵入人类大脑。被寄生失败的郑秀仁与寄生体海蒂共存，联手对抗不断扩散的寄生兽威胁。',
    longDescription: '某天，从天空降下了大量神秘孢子。这些孢子中诞生的寄生生物侵入人类大脑，控制人类身体。在被寄生失败后，便利店店员郑秀仁与寄生体海蒂形成了共生关系。与此同时，一个名为"灰色部队"的特别行动队正在全力追捕寄生兽。延尚昊导演又一力作，紧张刺激的科幻惊悚片。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20horror%20drama%20poster%2C%20woman%20with%20half%20transformed%20face%2C%20alien%20parasite%20tentacles%2C%20dark%20urban%20background%2C%20body%20horror%20theme%2C%20cinematic%20poster%20style&width=400&height=560&seq=show-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20dystopian%20Korean%20cityscape%2C%20alien%20spores%20falling%20from%20sky%2C%20eerie%20atmosphere%2C%20sci-fi%20horror%20cinematic%20wide%20shot%2C%20dark%20moody%20colors&width=1600&height=700&seq=show-banner-12&orientation=landscape',
    cast: ['全素妮', '具教焕', '李贞贤', '权海骁'],
    director: '延尚昊',
    tags: ['科幻', '惊悚', '寄生', '动作'],
    isHot: true,
    isNew: true,
    updateTime: '2024-04-05',
  },
];

export const bannerShows: Show[] = shows.filter(s => s.isHot).slice(0, 5);

export const hotShows: Show[] = shows.filter(s => s.isHot);

export const newShows: Show[] = shows.filter(s => s.isNew);

export const getShowsByCategory = (slug: string): Show[] => {
  if (slug === 'all') return shows;
  return shows.filter(s => s.categorySlug === slug);
};

export const getShowById = (id: number): Show | undefined => {
  return shows.find(s => s.id === id);
};